import classNames from 'classnames';
import React from 'react';
import styles from './grid-layout.module.css';
export function GridItemLayout(props) {
    return (React.createElement("div", { className: classNames(styles.gridItemLayoutChildren, { clickable: !!props.onClick }, "kplr_gridItemLayoutChildren"), onClick: props.onClick }, props.children));
}
export default GridItemLayout;
